import { motion } from "motion/react";

import cn from "@utils/helpers/cn";
import sx from "@utils/helpers/sx";

const variants = {
  hidden: {
    opacity: 0,
    scale: 1.1,
    transition: {
      delay: 0,
      duration: 0.5,
      ease: "easeOut",
    },
  },
  visible: {
    opacity: 1,
    scale: 1,
    transition: {
      delay: 0,
      duration: 0.5,
      ease: "easeOut",
    },
  },
};

const containerClassNames = cn(`
  relative
`);

const classNames = cn(`
  relative
  block
  animate-spin
  rounded-full
  opacity-100
`);

export default function CircleLoader(props) {
  const {
    size = "min(15vw, 15vh)",
    padding = "1rem",
    marginBottom = "20vh",
    marginLeft = "0",
    marginRight = "0",
    marginTop = "0",
    opacity = "1",
  } = props;

  return (
    <motion.div
      key="loader"
      className={containerClassNames}
      style={sx({
        __loaderMarginBottom: marginBottom,
        __loaderMarginLeft: marginLeft,
        __loaderMarginRight: marginRight,
        __loaderMarginTop: marginTop,
        __loaderPadding: padding,
        __loaderSize: size,
        marginBottom: "var(--loader-margin-bottom)",
        marginLeft: "var(--loader-margin-left)",
        marginRight: "var(--loader-margin-right)",
        marginTop: "var(--loader-margin-top)",
        padding: "var(--loader-padding)",
      })}
      variants={variants}
      initial="hidden"
      animate="visible"
      exit="hidden"
      layout={true}
    >
      <div
        className={classNames}
        style={sx({
          height: "var(--loader-size)",
          minHeight: "min(150px, var(--loader-size))",
          minWidth: "min(150px, var(--loader-size))",
          width: "var(--loader-size)",
          background: "radial-gradient(farthest-side, var(--loader-color) 94%, #00000000) top/9px 9px no-repeat, conic-gradient(#00000000 30%, var(--loader-color))",
          WebkitMask: "radial-gradient(farthest-side, #00000000 calc(100% - 9px), #000000 0)",
          opacity: opacity,
        })}
      />
    </motion.div>
  );
}
